import axiosInstance from '../axiosConfig';

export default {
  async sendShippingInfo(payload) {
    const response = await axiosInstance.post('EcomAgregarInfoEnvio', payload);
    return response.data;
  },
  async getShippingOptions(payload) {
    const response = await axiosInstance.post(
      'EcomSelFormaEnvioYCosto',
      payload
    );
    return response.data;
  },
  async sendShippingOption(payload) {
    const response = await axiosInstance.post('EcomAgregarFormaEnvio', payload);
    return response.data;
  },
};
